import { forwardRef, useState } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';

import { inputClass } from './TextField';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode;
  error?: string;
}

/** Поле пароля с кнопкой «показать/скрыть». */
export const PasswordField = forwardRef<HTMLInputElement, Props>(function PasswordField(
  { label, error, className = '', ...rest },
  ref,
) {
  const [visible, setVisible] = useState(false);
  return (
    <label className="block text-sm">
      {label && <span className="mb-1 block font-medium text-ink/80">{label}</span>}
      <span className="relative block">
        <input
          ref={ref}
          type={visible ? 'text' : 'password'}
          className={`${inputClass} pr-10 ${error ? 'border-danger' : ''} ${className}`}
          {...rest}
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-muted hover:text-ink"
          aria-label={visible ? 'Скрыть пароль' : 'Показать пароль'}
          title={visible ? 'Скрыть пароль' : 'Показать пароль'}
          aria-pressed={visible}
          onClick={() => setVisible((v) => !v)}
        >
          <EyeIcon crossed={visible} />
        </button>
      </span>
      {error && <span className="mt-1 block text-xs text-danger">{error}</span>}
    </label>
  );
});

function EyeIcon({ crossed }: { crossed: boolean }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
      {crossed && <path d="M3 3l18 18" />}
    </svg>
  );
}
